import {
  CreateBulkOrderRequest,
  CreateBulkOrderRequestOrderBasisAdjustmentsInner,
  CreateBulkOrderResponseDataInner,
  OrderInfoForBulkOrderInfo,
} from '@/coreInfrastructureModule/axios/generated/orderGroupManage';
import { ICombinedOrderState } from '../pages/useInventoryStore/type';
import { DateService } from '@/coreDomainsModule/services/dateService';
import { ICombinedOrderWithBusiness } from '../domains/entities/InventoryOrder';
import { ParentBusinessFactory } from '../domains/factories/ParentBusinessFactory';
import { OrderStatus } from '@/coreDomainsModule/entities/arrival';
import { OrderBasisUserAdjustedAdapter } from '@/coreUseCasesModule/orderBasis/adapters/OrderBasisUserAdjustedAdapter';

/**
 * まとめ発注のAdapter
 */
export class CombinedOrderAdapter {
  /**
   * リクエストを変換するAdapter
   * 基本的にupsertAndSingleSimulationOrderAdapterに合わせています。
   * @param requestInfo - リクエストする情報
   */
  public static adaptCombinedOrderRequest = (requestInfo: ICombinedOrderState): CreateBulkOrderRequest => {
    const targetDate = DateService.convertIDateToDate(requestInfo.desiredDeliveryDate);
    const orderInfoForBulkOrder: OrderInfoForBulkOrderInfo[] = [];
    const orderBasisAdjustments: CreateBulkOrderRequestOrderBasisAdjustmentsInner[] = [];
    requestInfo.confirmedOrdersWithBusinessAndAdjustment.forEach((orderBusinessAdjustment) => {
      orderInfoForBulkOrder.push({
        orderId: orderBusinessAdjustment.order.arrivalId,
        aggregateBusinessId: orderBusinessAdjustment.business.businessId,
        displayId: orderBusinessAdjustment.order.displayId,
        createdOrderDate: undefined,
        desiredDeliveryDate: DateService.formatDateToISOString(targetDate),
        estimatedTimeOfArrival: DateService.formatDateToISOString(targetDate),
        orderAmount: orderBusinessAdjustment.order.amount,
        orderStatus: OrderStatus.ApprovedAwaitingDeliveryDate, // 現状作成した取引は全て承認ステータスになる
        orderNote: orderBusinessAdjustment.order.memoText,
        updateAt: orderBusinessAdjustment.order.updateAt,
      });
      orderBasisAdjustments.push({
        aggregateBusinessId: orderBusinessAdjustment.business.businessId,
        adjustment: OrderBasisUserAdjustedAdapter.adapt(orderBusinessAdjustment.basisAdjustment),
      });
    });
    return {
      orderInfoForBulkOrder,
      orderBasisAdjustments,
      orderGroupName: requestInfo.groupName,
      invoiceNumber: requestInfo.invoiceNumber, // TODO: 現状未対応
      upperLimitQuantity: requestInfo.maxTotalAmount,
      destinationName: requestInfo.destinationName, // TODO: 現状未対応
      memo: requestInfo.memo, // TODO: 現状未対応
    };
  };

  /**
   * レスポンスを変換するAdapter
   * @param responseInfo - 帰ってきた情報
   */
  public static adaptCombinedOrderResponse = (responseInfo: CreateBulkOrderResponseDataInner[]): ICombinedOrderWithBusiness[] => {
    return responseInfo.map((info): ICombinedOrderWithBusiness => {
      return {
        business: ParentBusinessFactory.create({
          businessId: info.aggregateBusinessId,
          recommendEstimateTime: info.recommendEstimateTime ? DateService.convertUnixTimeToDate(info.recommendEstimateTime) : undefined,
          recommendArrivalValue: info.recommendArrivalValue ?? undefined,
        }),
        order: {
          displayId: info.displayId,
          orderNumber: '',
          arrivalId: info.orderId,
          crossDate: info.recommendCreatedOrderDate ? DateService.convertUnixTimeToIDate(info.recommendCreatedOrderDate) : undefined,
          fixOrderDate: undefined,
          amount: 0,
          leadTime: 0,
          isFixOrdered: false,
          status: undefined,
          memoText: undefined,
          partialDeliveries: undefined, // 分納の情報はここでは不要
          year: 0,
          month: 0,
          day: 0,
          number: undefined,
          updateAt: undefined,
        },
      };
    });
  };
}
